import { render, staticRenderFns } from "./IncomingInvoice.vue?vue&type=template&id=2f8a3859&"
import script from "./IncomingInvoice.vue?vue&type=script&lang=js&"
export * from "./IncomingInvoice.vue?vue&type=script&lang=js&"
import style0 from "./IncomingInvoice.vue?vue&type=style&index=0&id=2f8a3859&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports